module.exports = __webpack_public_path__ + "static/media/fluxodesativado.39e84aa4.png";